// In sviluppo locale, usa URL completo; in produzione usa percorso relativo
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api');

console.log('🔗 API Base URL:', API_BASE_URL);

// Helper per gestire risposte fetch
const handleResponse = async (response) => {
  if (!response.ok) {
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const error = await response.json().catch(() => ({ error: 'Errore sconosciuto' }));
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }
  
  // Verifica che la risposta sia JSON prima di parsarla
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  } else {
    throw new Error('Risposta non JSON ricevuta dal server');
  }
};

// Helper per richieste autenticate
const authenticatedFetch = async (url, options = {}) => {
  const token = localStorage.getItem('auth_token');
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers
  });

  return handleResponse(response);
};

// API Auth
export const authAPI = {
  register: async (email, password) => {
    try {
      console.log('🔐 Tentativo registrazione a:', `${API_BASE_URL}/auth/register`);
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      console.log('📡 Risposta ricevuta, status:', response.status);
      const data = await handleResponse(response);
      if (data.token) {
        localStorage.setItem('auth_token', data.token);
      }
      return data;
    } catch (error) {
      console.error('❌ Errore registrazione:', error);
      if (error.message === 'Failed to fetch') {
        throw new Error('Impossibile connettersi al server. Verifica che il backend sia in esecuzione su http://localhost:3001');
      }
      throw error;
    }
  },

  login: async (email, password) => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await handleResponse(response);
      if (data.token) {
        localStorage.setItem('auth_token', data.token);
      }
      return data;
    } catch (error) {
      console.error('Errore login:', error);
      throw new Error(error.message || 'Errore di connessione al server. Verifica che il backend sia in esecuzione.');
    }
  },

  logout: () => {
    localStorage.removeItem('auth_token');
  },

  getCurrentUser: async () => {
    return await authenticatedFetch(`${API_BASE_URL}/auth/me`);
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('auth_token');
  }
};

export const settingsAPI = {
  getSettings: async () => {
    return await authenticatedFetch(`${API_BASE_URL}/settings`);
  },

  saveSettings: async (settings) => {
    return await authenticatedFetch(`${API_BASE_URL}/settings`, {
      method: 'PUT',
      body: JSON.stringify(settings)
    });
  },

  resetSettings: async () => {
    return await authenticatedFetch(`${API_BASE_URL}/settings/reset`, {
      method: 'POST'
    });
  }
};